import { gql } from '@apollo/client'
import { PICTURES_LIST } from './picture'
import { ROLE } from './role'
import { ORGANIZATION_APPLICATION } from './organization'

export const PROFILE = gql`
  fragment Profile on User {
    id
    firstName
    lastName
    email
    certificates {
      id
      certificateType
      status
    }
    picture {
      ...PicturesList
    }
    userPreferences {
      notifyFallbackNoReceipentJob
      language
      hideTestOrganizations
      showActiveTemplatesOnly
      showDisabledProducts
      showDisabledVisuals
      showMyVisualsOnly
      showCustomerVisualsOnly
      unitSystem
      notifyFallbackNoReceipentJobForOrganizations
      lastMarketplaceOrganization
      seenItems
      enableRCMock
      enable3DCheckInsertMock
      sortBaseSkusBeforeVariations
      hasFavoriteJobbers
    }
    organizations {
      organization {
        ...OrganizationApplication
      }
      role {
        ...Role
      }
      status
    }
    role {
      ...Role
    }
    discord
  }
  ${PICTURES_LIST}
  ${ROLE}
  ${ORGANIZATION_APPLICATION}
`

export const PROFILE_EDIT = gql`
  fragment ProfileEdit on User {
    id
    firstName
    lastName
    email
    picture {
      ...PicturesList
    }
    userPreferences {
      notifyFallbackNoReceipentJob
      language
      hideTestOrganizations
      unitSystem
      notifyFallbackNoReceipentJobForOrganizations
      lastMarketplaceOrganization
      seenItems
      enableRCMock
      enable3DCheckInsertMock
      sortBaseSkusBeforeVariations
    }
    discord
  }
  ${PICTURES_LIST}
`
